<button *appIfDebugMode="true" mat-icon-button (click)="workItUpWhoop()">
  <mat-icon class="secondary-text">polymer</mat-icon>
</button>

<dx-popup
  [visible]="isVisible"
  [showTitle]="true"
  [showCloseButton]="true"
  (close)="workItUpWhoop()"
  title="Storage and Manutention"
  width="80%"
  height="80%">
  <mat-tab-group *appIfUserHas="['GOD_MODE']">
    <mat-tab label="Do Stuff">
      <button mat-button (click)="toolbarToolService.doStuff()">Do Stuff</button>
      <button mat-button (click)="toolbarToolService.delete3375()">Do Stuff</button>

    </mat-tab>
    <mat-tab label="Backend Call">
      <mat-form-field class="p-20">
        <input matInput type="text" [(ngModel)]="backendPath">
        <mat-label>Path:</mat-label>
      </mat-form-field>
      <mat-form-field class="p-20">
        <input matInput type="text" [(ngModel)]="action">
        <mat-label>Action:</mat-label>
      </mat-form-field>
      <div *ngFor="let params of paramsBackEnd; let index = index">
        <mat-form-field class="p-20">
          <input matInput type="text" [(ngModel)]="params[0]">
          <mat-label>Params:</mat-label>
        </mat-form-field>
        <mat-form-field class="p-20">
          <input matInput type="text" [(ngModel)]="params[1]">
          <mat-label>Value:</mat-label>
        </mat-form-field>
        <button mat-icon-button (click)="removeParamsBackEnd(index)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <button mat-icon-button (click)="addParamsBackEnd()">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-icon-button (click)="toolbarToolService.sendPostToBackEnd(backendPath, action, paramsBackEnd)">
        <mat-icon>send</mat-icon>
      </button>
    </mat-tab>
  </mat-tab-group>
</dx-popup>

